module.exports = __webpack_public_path__ + "static/media/task_warning_icon.92a9554c.svg";